import { render, staticRenderFns } from "./AlertComponent.vue?vue&type=template&id=3364a06d&scoped=true"
import script from "./AlertComponent.vue?vue&type=script&lang=ts"
export * from "./AlertComponent.vue?vue&type=script&lang=ts"
import style0 from "./AlertComponent.vue?vue&type=style&index=0&id=3364a06d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3364a06d",
  null
  
)

export default component.exports